import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChampionTestimonial, DynamicTranslationService } from '@gs-2.0/core';

export interface ViewChampionFormDialogData {
  testimonial: ChampionTestimonial;
}

@Component({
  selector: 'app-view-champion-form-dialog',
  standalone: false,
  templateUrl: './view-champion-form-dialog.component.html',
  styleUrls: ['./view-champion-form-dialog.component.scss']
})
export class ViewChampionFormDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ViewChampionFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ViewChampionFormDialogData,
    private translationService: DynamicTranslationService
  ) {}

  get testimonial(): ChampionTestimonial {
    return this.data.testimonial;
  }

  getMonthName(month: number): string {
    const months = ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'];
    return months[month - 1] || '';
  }

  getDescription(): string {
    return this.translationService.instant('settings.champions.view_form.description', {
      organizationName: this.testimonial.organisationName
    });
  }

  getFileName(fullPath: string): string {
    // Extract filename from format: uuid/file-type/filename
    if (!fullPath) return '';
    const parts = fullPath.split('/');
    return parts.length > 0 ? parts[parts.length - 1] : fullPath;
  }

  openMediaPreview(): void {
    if (this.testimonial.media?.url) {
      window.open(this.testimonial.media.url, '_blank');
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
